import gql from 'graphql-tag';

export const GET_DEAL_BUILDER_CUSTOMER_CONTACTS = gql`
  query GetDealBuilderCustomerContacts($customerAccountId: ID!) {
    customer {
      customerContacts(customerAccountId: $customerAccountId) {
        error
        success
        list {
          firstName
          lastName
          title
          phone
          email
          contactType

          accountContactDetails {
            id
            email
          }

          ownerPgDetails {
            ownerPgId
            creditApplicationId
            pc
          }
        }
      }
    }
  }
`;
